export const PORTFOLIO_WORKLOAD_CONFIG = {
    name            : 'Workload',
    menuName        : 'Workload',
    icon            : 'i5-timeline',
    // iconLight       : 'i5-workload-light',
    image           : 'workload',
    iconSvg         : 'isvg-view-workload',
    url             : 'workload',
    stringId        : 'workload',
    proOnly         : true,
    description     : 'View and manage the team\'s workload, allocate resources, and schedule work items.'
}
